import { render, staticRenderFns } from "./KpiPrincipal.vue?vue&type=template&id=4d247f9f&scoped=true"
import script from "./KpiPrincipal.vue?vue&type=script&lang=js"
export * from "./KpiPrincipal.vue?vue&type=script&lang=js"
import style0 from "./KpiPrincipal.vue?vue&type=style&index=0&id=4d247f9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d247f9f",
  null
  
)

export default component.exports